<template>
  <div class="section">
    <div class="columns">
      <div class="column">
        <div class="card login-card">
          <div class="login-logo">
            <p>
              <img :src="getImage('logo.png')" alt="RM Logo" />
            </p>
          </div>
          <div class="login-header">Login</div>
          <div class="card-body">
            <div v-if="error" class="has-text-danger mb-1 mt-1">
              {{ error }}
            </div>
            <form action="#" @submit.prevent="submit">
              <div class="content">
                <label
                  for="email"
                  class="col-form-label text-md-right"
                >
                  <strong>Email</strong>
                </label>

                <div class="content">
                  <input
                    id="email"
                    type="email"
                    class="input"
                    name="email"
                    value
                    required
                    autofocus
                    v-model="form.email"
                  />
                </div>
              </div>

              <div class="content">
                <label for="password">
                  <strong>Password</strong>
                </label>

                <div>
                  <input
                    id="password"
                    type="password"
                    class="input"
                    name="password"
                    required
                    autocomplete="off"
                    v-model="form.password"
                  />
                </div>
              </div>

              <div class="card-footer">
                <p class="mt-1">
                  <button type="submit" class="button is-info">Login</button>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";


export default {
  name: "Login",
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  methods: {
    submit() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .then(data => {
          console.log(data);
          this.$store.dispatch("updateUserState", data.user);
          this.$router.push({ name: "HomePage" });
          // location.href = "https://rmofchaplin.ca/admin/homepage"
        })
        .catch(err => {
          this.error = err.message;
        });
    },
    getImage(img) {
      return process.env.VUE_APP_SERVER + "uploads/" + img;
    }
  }
};
</script>

<style lang="scss">
@import "@/assets/basic.scss";
.login-card {
  max-width: 400px !important;
  margin: 1rem auto;
  padding: 1rem;

  .login-logo {
    margin: 1rem auto;
  }

  .login-header {
    padding-bottom: 0.5rem;
    margin-bottom: 1rem;
    border-bottom: 2px solid hsl(204, 86%, 53%);
    font-weight: bold;
    font-size: 1.25rem;
  }

  .card-footer {
    p {
      text-align: right !important;

      button {
        display: inline-block;
      }
    }
  }

  .input {
    width: 100% !important;
    display: block;
  }
}
</style>
